module.exports = __webpack_public_path__ + "static/media/em-114.11d5aedd.png";